import { Tooltip } from '@material-ui/core';
import { ArticleCategory, ArticleType } from '@nemuru-eng/js-api-client';

import { ArticleTypeMap } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/maps/ArticleTypeMap';
import { Icon } from '@/components/shared/components/Icon';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

interface DescriptionFieldTooltipProps {
  type: ArticleType;
  category: ArticleCategory;
}

export const DescriptionFieldTooltip = ({ type, category }: DescriptionFieldTooltipProps) => {
  const { getTextIdTranslation } = useTranslation();

  const tooltipTitle = [ArticleCategory.PHYSICAL, ArticleCategory.DIGITAL].includes(category)
    ? `${getTextIdTranslation(type)} ${getTextIdTranslation(category)}`
    : getTextIdTranslation(category);

  return (
    <Tooltip title={tooltipTitle} placement="bottom">
      <div style={{ marginBottom: '-5px' }}>
        <Icon size={20}>{ArticleTypeMap.toIcon(type)}</Icon>
      </div>
    </Tooltip>
  );
};
